module.exports = "/assets/data/f0c5b13b1820249aaf2b82b4f9b3eb34-BS39.data.json";